import React, {useState} from 'react';

import TimelineContainer from "../../../containers/TimelineContainer";
import {BookmarkState, BookmarkType} from "../../../store/bookmarks/types";
import BookmarksTitleComponent from "../BookmarksTitleComponent";
import BookmarksContentComponent from "../BookmarksContentComponent";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";
import {setCheckedPane} from "../../../store/layouts/actions";
import PlayerContainer from "../../../containers/PlaybackPlayer";
import BookmarksPaneContainer from "../../../containers/BookmarksPaneContainer";
import {deleteBookmark, setSelectedItems, setBookmarkCheckedPane} from "../../../store/bookmarks/actions";
import './style.scss';
import BkmWarningForDeleteComponent from "../BkmWarningForDeleteComponent";
import { setPlaybackmode } from '../../../store/timeline/actions';


interface Props {
    bookmarksData: BookmarkType[]
}



export const triggerSingleCheck = (items: Array<number | string>, id: number | string) => {
    let prevSelected;
    let selectedItems : any[] = [];
    if (items.length === 1 && items[0] === id) {
        prevSelected = null;
    } else {
        selectedItems = [id];
        prevSelected = id;
    }
    return { selectedItems, prevSelected }
};

export const triggerCtrlCheck = (items: Array<number | string>, id: number | string) => {
    const ind = items.indexOf(id);
    let selectedItems = ind > -1 ?
        [...items.splice(0, ind), ...items.splice(ind + 1)]
        : [...items.splice(0), id];

    const prevSelected = selectedItems.length ? selectedItems[selectedItems.length - 1] : null;

    return { selectedItems, prevSelected }
};


const BookmarkComponent: React.FC<Props> = ({bookmarksData}) => {
    const { checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { expanded, selected, bookmarks } = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);

    const [warningToDelIds, setWarningToDel] = useState<null | Array<number | string>>(null);
    const dispatch = useDispatch();

    const doCheckedPane = (pane: number) => {
        if (checkedPane !== pane) {
            if (bookmarks?.[pane]?.timeBounds) {
                dispatch(setBookmarkCheckedPane(pane, bookmarks[pane].timeBounds.start));
            } else {
                dispatch(setPlaybackmode('pause', true));
                dispatch(setCheckedPane(pane));
            }
        }
    };

    const doDeleteBookmark = (ids: Array<number | string>) => {
        dispatch(deleteBookmark(ids));
        setWarningToDel(null)
    };

    const doSelect = (e: React.MouseEvent, id: number) => {
        const {selectedItems} = e.ctrlKey
            ? triggerCtrlCheck(selected, id)
            : triggerSingleCheck(selected, id);

        dispatch(setPlaybackmode('pause', true));
        dispatch(setSelectedItems(selectedItems))
    };

    return (
        <>
        <div className='w-100 features'>
            <div className='features-layout'
                 style={{height: `${window.CONFIG.browseLayout.height}vh`}}
            >
                <div className='features-layout__item'
                     style={expanded !== null ? {height: '100%'} : {} }
                >
                    <div className={checkedPane === 0 ? 'features-layout-item__pane checked' : 'features-layout-item__pane'}
                         onClick={() => doCheckedPane(0)}
                         style={expanded === 1 ? {display: 'none'} : {} }
                    >
                        <BookmarksPaneContainer pane={0}/>
                    </div>
                    <div className={checkedPane === 1 ? 'features-layout-item__pane checked' : 'features-layout-item__pane'}
                         onClick={() => doCheckedPane(1)}
                         style={expanded === 0 ? {display: 'none'} : {} }
                    >
                        <BookmarksPaneContainer pane={1}/>
                    </div>
                </div>
                {
                    expanded === null && <div className='features-layout__item bookmarks'
                                              style={expanded !== null ? {height: 0} : {} }
                    >
                        <div style={{height: '40px'}} />
                        <div className='w-100 h-100 pos-rel '>
                            <BookmarksTitleComponent
                                deleteBkm={(ids: Array<string | number>) => setWarningToDel(ids)}
                            />

                            <div className='bookmarks__container scroll'
                                 id='bkm-content'
                            >
                                <BookmarksContentComponent
                                    bookmarks={bookmarksData}
                                    doSelect={doSelect}
                                    deleteBkm={(ids: Array<string | number>) => setWarningToDel(ids)}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
            <TimelineContainer />
            <PlayerContainer />
        </div>
            {
                warningToDelIds &&
                    <BkmWarningForDeleteComponent
                        onCancel={() => setWarningToDel(null)}
                        onSubmit={() => doDeleteBookmark(warningToDelIds)}
                        ids={warningToDelIds}
                    />
            }
        </>
    );
};

export default BookmarkComponent;